// extracted by mini-css-extract-plugin
export default {"container":"WizardSpinner_container__kJuUq","spinner":"WizardSpinner_spinner__ahmrp","spin":"WizardSpinner_spin__IEtxv","message":"WizardSpinner_message__uCwrx"};